// height product info on collection page
function setMaxHeightForElements(selector, itemsRow = false) {
  const elements = document.querySelectorAll(selector);

  function getItemsPerRow() {
    const screenWidth = window.innerWidth;

    console.log(itemsRow);
    
    if (itemsRow) {
      return 1000;
    }
    console.log("ого мимо");
    

    if (screenWidth >= 2035) return 8;
    if (screenWidth >= 1780) return 7;
    if (screenWidth >= 1525) return 6;
    if (screenWidth >= 1270) return 5;
    if (screenWidth >= 1015) return 4;
    if (screenWidth >= 850) return 3;
    if (screenWidth >= 715) return 4;
    if (screenWidth >= 535) return 3;
    if (screenWidth >= 355) return 2;
    return 1;
  }


  const itemsPerRow = getItemsPerRow();
  const rows = [];

  let currentRow = [];
  elements.forEach(el => {
    currentRow.push(el);
    if (currentRow.length === itemsPerRow) {
      rows.push(currentRow);
      currentRow = [];
    }
  });

  if (currentRow.length) {
    rows.push(currentRow);
  }

  rows.forEach(row => {
    let maxHeight = 0;
    row.forEach(el => {
      el.style.height = 'auto';
      if (el.offsetHeight > maxHeight) maxHeight = el.offsetHeight;
    });

    row.forEach(el => {
      el.style.height = maxHeight + 'px';
    });
  });
}


if (document.querySelector('.CollectionDesign .Grid__Item')) {
  setMaxHeightForElements('.CollectionDesign .Grid__Item .ProductCard__Info');

  window.addEventListener('resize', () => {
    setMaxHeightForElements('.CollectionDesign .Grid__Item .ProductCard__Info');
  });
}


setTimeout(() => {
  document.querySelectorAll(".ProductCard").forEach((productCard, index) => {
    setTimeout(() => {
      const swiper = productCard.querySelector(".swiper");
      const swiperPagination = productCard.querySelector(".swiper-pagination");
      const swiperButtonNext = productCard.querySelector(".swiper-button-next");
      const swiperButtonPrev = productCard.querySelector(".swiper-button-prev");
      const slider = new Swiper(swiper, {
        slidesPerView: 1,
        grabCursor: true,
        centeredSlides: true,
        spaceBetween: 12,
        touchReleaseOnEdges: true,
        mousewheel: {
            forceToAxis: true
        },
        pagination: {
          el: swiperPagination,
          clickable: true,
        },
        navigation: {
          nextEl: swiperButtonNext,
          prevEl: swiperButtonPrev,
        },
      });
    }, index*100);

    setTimeout(() => {
      productCard.classList.add("show-slider-component");
      setTimeout(() => {
        productCard.classList.remove("show-slider-component");
      }, 400);
    }, index*100 + 2000);
  });

}, 100);



document.querySelectorAll(".product-media__gallery.js").forEach(section => {
  section.classList.remove("js");
  const galleryMainElement = section.querySelector(".gallery-main");
  const swiperPagination = section.querySelector(".swiper-pagination");
  const swiperButtonNext = section.querySelector(".swiper-button-next");
  const swiperButtonPrev = section.querySelector(".swiper-button-prev");


  const galleryMain = new Swiper(galleryMainElement, {
    slidesPerView: 1.5,
    spaceBetween: 12,
    touchReleaseOnEdges: true,
    mousewheel: {
      forceToAxis: true
    },
    navigation: {
      nextEl: swiperButtonNext,
      prevEl: swiperButtonPrev,
    },
    pagination: {
      el: swiperPagination,
      clickable: true,
      type: "bullets",
    },
    breakpoints: {
      575: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 3,
      },
      1008: {
        slidesPerView: 1.5,
        pagination: {
          el: swiperPagination,
          type: "progressbar",
        },
      },
      1500: {
        slidesPerView: 2,
      },
    },
  });

  // window.addEventListener('resize', function() {
  //   if (window.innerWidth > 1008) {
  //     if (galleryMain.pagination && galleryMain.pagination.el) {
  //       galleryMain.pagination.type = 'progressbar';
  //       galleryMain.update();
  //     }
  //   } else {
  //     if (galleryMain.pagination && galleryMain.pagination.el) {
  //       galleryMain.pagination.type = 'bullets';
  //       galleryMain.update();
  //     }
  //   }
  // });

  // scroll the gallery to the picture matching the selected color swatch (size is ignored)
  const productSection = section.closest("section-product") || document;
  const productJsonScript = productSection.querySelector("[data-product-json]");
  let productData = null;

  if (productJsonScript) {
    try {
      productData = JSON.parse(productJsonScript.textContent).product;
    } catch (e) {
      productData = null;
    }
  }

  productSection.addEventListener("change", function (event) {
    const target = event.target;
    if (!productData || !target.matches('.ProductForm__Option [type="radio"]')) return;

    const label = target.nextElementSibling;
    if (!label || !(label.classList.contains("ImageSwatch") || label.classList.contains("ColorSwatch"))) return;

    const optionKey = "option" + target.getAttribute("data-option-position");
    const value = target.value;

    const matchedVariant = productData.variants.find(function (variant) {
      return variant[optionKey] === value && variant.featured_media;
    });

    if (!matchedVariant) return;

    const slides = galleryMainElement.querySelectorAll(".swiper-slide");
    for (let i = 0; i < slides.length; i++) {
      if (parseInt(slides[i].getAttribute("data-media-id"), 10) === matchedVariant.featured_media.id) {
        galleryMain.slideTo(i);
        break;
      }
    }
  });

});



// pseudo hover on mobile devises
function isMobileScreen() {
  return window.innerWidth <= 1024;
}
function handleTouchEvent(event) {
  const productCards = document.querySelectorAll('.ProductCard');
  if (!isMobileScreen()) {
    return;
  }
  productCards.forEach(card => card.classList.remove('hover'));
  const targetCard = Array.from(productCards).find(card => card.contains(event.target));
  if (targetCard) {
    targetCard.classList.add('hover');
  }
}
function handleResize() {
  if (isMobileScreen()) {
    document.addEventListener('touchstart', handleTouchEvent);
  } else {
    document.removeEventListener('touchstart', handleTouchEvent);
    document.querySelectorAll('.ProductCard').forEach(card => card.classList.remove('hover'));
  }
}

window.addEventListener('resize', handleResize);
handleResize();


// bottom menu mobile
document.addEventListener('DOMContentLoaded', function () {
  const menuItems = document.querySelectorAll('.mobile-menu-item');
  const menuTitles = document.querySelectorAll('.mobile-menu-title');

  function closeAllMenus() {
    menuItems.forEach(item => {
      item.classList.remove('active');
      const links = item.querySelector('.mobile-menu-links');
      if (links) {
        links.style.maxHeight = null;
      }
    });
  }

  menuTitles.forEach(title => {
    title.addEventListener('click', function (e) {
      e.stopPropagation();

      const item = this.closest('.mobile-menu-item');
      const links = item.querySelector('.mobile-menu-links');
      const isOpen = item.classList.contains('active');

      closeAllMenus();

      if (!isOpen) {
        item.classList.add('active');
        // 👇 задаём точную высоту для плавности
        links.style.maxHeight = links.scrollHeight + 'px';
      }
    });
  });

  document.addEventListener('click', closeAllMenus);

  let scrollLock = false;
  window.addEventListener(
    'scroll',
    function () {
      if (scrollLock) return;
      scrollLock = true;

      closeAllMenus();

      setTimeout(() => {
        scrollLock = false;
      }, 100);
    },
    { passive: true }
  );
});


// button to top
const toTopButton = document.querySelector('.mobile-menu-to-top');
function checkScroll() {
  if (window.scrollY === 0) {
    toTopButton.classList.add('disabled');
  } else {
    toTopButton.classList.remove('disabled');
  }
}

toTopButton.addEventListener('click', () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
});
window.addEventListener('scroll', checkScroll);
window.addEventListener('load', checkScroll);

// button back
const backButton = document.querySelector('.mobile-menu-back');
backButton.addEventListener('click', () => {
  if (window.history.length > 1) {
    window.history.back();
  } else {
    window.location.href = '/';
  }
});